module.exports = "<div\n\tclass=\"svg-img-wrapper\"\n\t[innerHTML]=\"svgHtml\">\n</div>\n"